import { Injectable } from '@angular/core';

import { Loader } from './loader';

@Injectable()
export class LoaderService {
	private loader: Loader = { on: false };

	constructor() {
		console.log('Loader service instantiated ...');
	}

	public get getFlag(): Loader {
		return this.loader;
	}

	public set setLoader(flag: boolean) {
		this.loader.on = flag;
	}
}
